import router from '@/router'
import { LogisticTransportApi } from '@/api/Logistic'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { showAlertError } from '@/utils/store/alert'

const initialState = () => {
  return {
    api: LogisticTransportApi,

    ...vuexFileBase.createState(['scans']),

    id: null,
    transport: {
      name: '',
      sort_order: '0',
      number: '',
      comment: '',
      price_intex: '',
      price_satka: '',
      price_mgn: '',
      driver_rate: '',
      price_repair: '',
      drivers: [],
      is_not_odometer: false,
      fuels: [],
      scans: []
    },

    fuelsModal: {
      active: false,
      updatedId: null
    },
    fuels: [],
    fuelsHeader: {
      allActive: false,
      isActiveDelete: false,
      headers: [
        {
          title: 'Тип топлива',
          isSortable: false
        },
        {
          title: 'Код',
          isSortable: false
        },
        // {
        //   title: 'Норма расхода на 100км',
        //   isSortable: false
        // },
        {
          title: 'Норма расхода на 100км (летом)',
          isSortable: false
        },
        {
          title: 'Норма расхода на 100км (зимой)',
          isSortable: false
        }
      ]
    },
    fuelsModalHeader: {
      allActive: false,
      headers: [
        {
          title: 'Тип топлива',
          isSortable: false
        },
        {
          title: 'Код',
          isSortable: false
        }
      ]
    },
    consumptionModal: {
      active: false,
      updatedId: '',
      name: '',
      // value: '',
      values: {
        consumptionSummer: '',
        consumptionWinter: ''
      }
      // validation: {
      //   value: {
      //     type: null,
      //     message: ''
      //   }
      // }
    },
    validation: {
      name: {
        type: null,
        message: ''
      },
      sort_order: {
        type: null,
        message: ''
      },
      number: {
        type: null,
        message: ''
      }
    },
    isLoading: false,
    params: {
      expand: 'drivers,waybills,fuel,scans'
    }
  }
}

const state = initialState

const getters = {
  getTransportItemFuels: state => state.fuels.map((fuel) => {
    return {
      id: fuel.id,
      isActive: fuel.isActive,
      values: [
        fuel.name,
        fuel.code
      ]
    }
  }),
  getTransportItemAddedFuels: state => {
    const l = state.transport.fuels?.length
    return state.transport.fuels.map(fuel => ({
      id: fuel.id,
      isActive: fuel.isActive,
      l,
      values: [
        { data: fuel.name, mod: '' },
        { data: fuel.code, mod: '' },
        // средний расход на 100 км
        // { data: fuel.consumption_rate, mod: '' },
        { data: fuel?.consumption_rate_summer, mod: '' },
        { data: fuel?.consumption_rate_winter, mod: '' }
      ]
    }))
  }
}

const mutations = {
  ...vuexFileBase.createMutations(),

  SET_TRANSPORT_ITEM: (state, transport) => {
    state.transport = {
      ...transport,
      sort_order: `${transport.sort_order}`,
      scans: transport.scans ? transport.scans.map(e => {
        return {
          name: e.file_name,
          size: e.file_size,
          url: e.url,
          type: e.content_type,
          id: e.id
        }
      }) : [],
      fuels: transport.fuel ? transport.fuel.map(e => {
        return {
          name: e.name,
          code: e.code,
          id: e.id,
          consumption_rate: e.pivot.consumption_rate,
          consumption_rate_summer: e.pivot.consumption_rate_summer || null,
          consumption_rate_winter: e.pivot.consumption_rate_winter || null
        }
      }) : []
    }
    state.id = transport.id
  },
  SET_TRANSPORT_ITEM_INITIAL_STATE: (state) => {
    Object.assign(state, initialState())
  },
  SET_TRANSPORT_ITEM_FUELS: (state, fuels) => {
    state.fuels = fuels.map(fuel => {
      return {
        id: fuel.id,
        isActive: false,
        name: fuel.name,
        code: fuel.code,
        consumption_rate: fuel.consumption_rate || null,
        consumption_rate_summer: fuel.consumption_rate_summer || null,
        consumption_rate_winter: fuel.consumption_rate_winter || null
      }
    })
  },
  SET_TRANSPORT_ITEM_IS_LOADING: (state, bool) => {
    state.isLoading = bool
  },
  SET_TRANSPORT_ITEM_NAME: (state, value) => {
    state.transport.name = value
  },
  SET_TRANSPORT_ITEM_NUMBER: (state, value) => {
    state.transport.number = value
  },
  SET_TRANSPORT_ITEM_COMMENT: (state, value) => {
    state.transport.comment = value
  },
  SET_TRANSPORT_ITEM_SCANS: (state, value) => {
    state.transport.scans = value
  },
  SET_TRANSPORT_ITEM_SORT_ORDER: (state, value) => {
    state.transport.sort_order = value
  },
  SET_TRANSPORT_ITEM_PRICE_MGN: (state, value) => {
    state.transport.price_mgn = value
  },

  SET_TRANSPORT_ITEM_PRICE_SATKA: (state, value) => {
    state.transport.price_satka = value
  },
  SET_TRANSPORT_ITEM_PRICE_INTEX: (state, value) => {
    state.transport.price_intex = value
  },
  SET_TRANSPORT_ITEM_PRICE_DRIVER: (state, value) => {
    state.transport.driver_rate = value
  },
  SET_TRANSPORT_ITEM_PRICE_REPAIR: (state, value) => {
    state.transport.price_repair = value
  },
  SET_TRANSPORT_ITEM_ODOMETER: (state) => {
    state.transport.is_not_odometer = !state.transport.is_not_odometer
  },
  SET_TRANSPORT_ITEM_VALIDATION: (state, valid) => {
    if (valid.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
    }
    if (valid.number) {
      state.validation.number.message = valid.number[0]
      state.validation.number.type = 'error'
    }
    if (valid.sort_order) {
      state.validation.sort_order.message = valid.sort_order[0]
      state.validation.sort_order.type = 'error'
    }
  },
  CLEAR_TRANSPORT_ITEM_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.validation.name = {
          type: null,
          message: ''
        }
        break
      case 'sort_order':
        state.validation.sort_order = {
          type: null,
          message: ''
        }
        break
      case 'number':
        state.validation.number = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  OPEN_TRANSPORT_ITEM_FUELS_MODAL: (state) => {
    state.fuelsModal.active = true
  },
  CLOSE_TRANSPORT_ITEM_FUELS_MODAL: (state) => {
    state.fuelsModal.active = false
    state.fuelsModal.updatedId = null
    state.fuelsModalHeader.allActive = false
    state.fuels.forEach(e => {
      e.isActive = false
    })
  },

  TOGGLE_TRANSPORT_ITEM_CHECK_ALL_FUELS: (state) => {
    state.fuelsModalHeader.allActive = !state.fuelsModalHeader.allActive
    state.fuels.forEach(e => {
      e.isActive = state.fuelsModalHeader.allActive
    })
  },
  ADD_TRANSPORT_ITEM_MODAL_SELECTED_FUELS: (state) => {
    const selectedItemsSet = []
    state.fuels.forEach((elem) => {
      if (elem.isActive) {
        if (!state.transport.fuels.some(item => item.id === elem.id)) {
          // Глубокое копирование объектов
          selectedItemsSet.push(JSON.parse(JSON.stringify(elem)))
        }
      }
    })
    // Убираем isActive после копирования
    selectedItemsSet.forEach(e => {
      e.isActive = false
    })

    state.transport.fuels.push(...selectedItemsSet)
  },
  TOGGLE_TRANSPORT_ITEM_MODAL_CHECK_SINGLE_FUEL: (state, itemId) => {
    const itemsLength = state.fuels.length
    let counter = 0

    state.fuels.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    // counter > 0 ? state.selectedWorkerIsActiveDelete = true : state.selectedWorkerIsActiveDelete = false

    state.fuelsModalHeader.allActive = counter === itemsLength
  },
  OPEN_TRANSPORT_ITEM_CONS_MODAL: (state, itemId) => {
    const consModal = state.consumptionModal
    const item = state.transport.fuels.filter(e => e.id === itemId)[0]

    consModal.active = true
    consModal.value = item.consumption_rate
    consModal.name = item.name
    consModal.updatedId = item.id
  },
  CLOSE_TRANSPORT_ITEM_CONS_MODAL: (state) => {
    const consModal = state.consumptionModal
    consModal.active = false
    consModal.value = null
    consModal.name = null
  },

  SET_FUEL_ITEM_FUEL_CONS_VALUE: (state, value) => {
    state.consumptionModal.value = value
  },
  SET_FUEL_ITEM_FUEL_CONS_SUMMER: (state, value) => {
    state.consumptionModal.values.consumptionSummer = value
  },
  SET_FUEL_ITEM_FUEL_CONS_WINTER: (state, value) => {
    state.consumptionModal.values.consumptionWinter = value
  },

  SET_FUEL_ITEM_FUEL_CONS: (state) => {
    const consModal = state.consumptionModal

    const index = state.transport.fuels.findIndex(e => e.id === consModal.updatedId)

    state.transport.fuels[index].consumption_rate = consModal.value
    state.transport.fuels[index].consumption_rate_summer = consModal.values.consumptionSummer
    state.transport.fuels[index].consumption_rate_winter = consModal.values.consumptionWinter
  },
  TOGGLE_TRANSPORT_ITEM_CHECK_ALL_SELECTED_FUELS: (state) => {
    state.fuelsHeader.allActive = !state.fuelsHeader.allActive
    state.fuelsHeader.allActive ? state.fuelsHeader.isActiveDelete = true : state.fuelsHeader.isActiveDelete = false

    state.transport.fuels.forEach(e => {
      e.isActive = state.fuelsHeader.allActive
    })
  },
  TOGGLE_TRANSPORT_ITEM_CHECK_SINGLE_SELECTED_FUEL: (state, itemId) => {
    const itemsLength = state.transport.fuels.length
    let counter = 0

    state.transport.fuels.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.fuelsHeader.isActiveDelete = true : state.fuelsHeader.isActiveDelete = false

    state.fuelsHeader.allActive = counter === itemsLength
  },
  DELETE_TRANSPORT_ITEM_SELECTED_CHECKED_FUELS: (state) => {
    state.transport.fuels = state.transport.fuels.filter(e => !e.isActive)
    state.fuelsHeader.isActiveDelete = false
  }
}

const actions = {
  ...vuexFileBase.createActions(),

  async getTransportItem ({ commit, state }, id) {
    try {
      commit('SET_TRANSPORT_ITEM_IS_LOADING', true)
      const response = await LogisticTransportApi.getById(id, state.params)
      commit('SET_TRANSPORT_ITEM', response.data.data)
    } catch (e) {
      showAlertError(e)
    } finally {
      commit('SET_TRANSPORT_ITEM_IS_LOADING', false)
    }
  },

  async saveTransportItem ({ commit, state, dispatch }) {
    const data = {
      name: state.transport.name,
      number: state.transport.number,
      comment: state.transport.comment,
      is_not_odometer: state.transport.is_not_odometer,
      sort_order: state.transport.sort_order,
      price_intex: state.transport.price_intex,
      price_satka: state.transport.price_satka,
      price_mgn: state.transport.price_mgn,
      fuel: state.transport?.fuels?.length ? state.transport.fuels.map((elem) => {
        return {
          fuel_id: elem.id,
          consumption_rate: elem.consumption_rate,
          consumption_rate_summer: elem.consumption_rate_summer,
          consumption_rate_winter: elem.consumption_rate_winter
        }
      }) : null,
      driver_rate: state.transport.driver_rate,
      price_repair: state.transport.price_repair,
      drivers: state.transport?.drivers?.length ? state.transport.drivers.map(e => e.id) : null
    }

    try {
      if (!state.id) {
        await dispatch('createTransport', data)
      } else {
        await dispatch('updateTransport', { id: state.id, data })
      }

      await router.push({ name: 'LogisticTransportList' })
    } catch (e) {
      showAlertError(e)
      commit('SET_TRANSPORT_ITEM_VALIDATION', e.response.data.validation)
    }
  },

  async createTransport ({ state, dispatch }, data) {
    const response = await LogisticTransportApi.create(data)
    const id = response.data.data.id
    await dispatch('checkAndPostNewFiles', {
      id,
      data: state.transport,
      addExpand: false
    })
  },

  async updateTransport ({ state, dispatch }, { id, data }) {
    await LogisticTransportApi.update(id, data)
    await dispatch('checkAndDeleteFiles', id)
    await dispatch('processPostAndSortFiles', { id, data: state.transport })
  },

  addScanFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: 'scans' })
  },

  addTransportItemSelectedFuels ({ commit }) {
    commit('ADD_TRANSPORT_ITEM_MODAL_SELECTED_FUELS')
    commit('CLOSE_TRANSPORT_ITEM_FUELS_MODAL')
  },

  addTransportItemFuelCons ({ commit }) {
    commit('SET_FUEL_ITEM_FUEL_CONS')
    commit('CLOSE_TRANSPORT_ITEM_CONS_MODAL')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
